import React, { Component } from "react";
import EditableTable from "@components/Table/EditableTable";
import TextArea from "antd/es/input/TextArea";
import { api } from "@redux/api";
import { useAuth, AUTH_LEVEL } from "@/hooks/use-auth";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const TEMPLATE_LIST_PATH = "/admin/equipment-category-template";
const TEMPLATE_DETAIL_PATH = "/admin/equipment-category-template-detail";
const TEMPLATE_CREATE_PATH = "/admin/create-equipment-category-template";

const GotoDetail = ({ id, label }) => {
  const { navigateAndCloseTabs } = useSmartNavigate();
  const handleClick = (e) => {
    e.stopPropagation();
    navigateAndCloseTabs(`${TEMPLATE_DETAIL_PATH}/${id}`, `${TEMPLATE_DETAIL_PATH}/`);
  };
  return <a onClick={handleClick}>{label || <i className="fas fa-expand-arrows-alt text-lg" />}</a>;
};

const columns = [
  {
    title: "key",
    dataIndex: "id",
    key: "id",
    editable: false,
    search: false,
    importIngore: true,
    hideInTable: true,
    width: "4%",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    search: false,
    edit: true,
    sorter: (a, b) => a.name?.localeCompare(b.name),
    formItemProps: {
      rules: [{ required: true, message: "required" }],
    },
    render: (text, record) => <GotoDetail id={record.id} label={text} />,
    renderFormItem: () => <TextArea rows={1} />,
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    search: false,
    edit: true,
    hideInTable: window.innerWidth < 760,
    renderFormItem: () => <TextArea rows={2} />,
  },
  {
    title: "Created Date",
    dataIndex: "created_date",
    key: "created_date",
    search: false,
    edit: false,
    hideInTable: window.innerWidth < 760,
  },
];

const columnProps = {
  title: "equipmentCategoryTemplate",
  name: "equipmentCategoryTemplate",
  description: "",
};

class EquipmentCategoryTemplate extends Component {
  state = {
    data: [],
    isLoading: false,
  };

  handleFilter = (query) => {
    this.setState({ isLoading: true });
    return api
      .filterEquipmentCategoryTemplates(query || "")
      .then((response) => ({
        data: response.data.results,
        success: true,
        total: response.data.count,
      }))
      .catch((error) => error);
  };

  getRecords = (data) => {
    this.setState({ data, isLoading: false });
  };

  handleDelete = (id) =>
    api.deleteEquipmentCategoryTemplate(id).then((response) => response.data).catch((error) => error);

  handleBulkDelete = (body) => {
    const payload = Array.isArray(body)
      ? { ids: body.map((row) => (row && typeof row === "object" ? row.id : row)).filter(Boolean) }
      : body;
    return api.bulkDeleteEquipmentCategoryTemplates(payload).then((response) => response.data).catch((error) => error);
  };

  handOnlineSave = (key, row) =>
    api.editEquipmentCategoryTemplate(key, row).then((response) => response).catch((error) => error);

  render() {
    return (
      <div>
        <EditableTable
          columns={columns}
          data={this.state.data}
          columnProps={columnProps}
          getRecord={this.getRecords}
          deleteRecord={this.handleDelete}
          bulkDelete={this.handleBulkDelete}
          handOnlineSave={this.handOnlineSave}
          handleFilter={this.handleFilter}
          hide_search
          hide_imports
          isRowClickable={false}
          isRelated={false}
          isAttachments={false}
          hid_new={!this.props.canWrite}
          canDelete={this.props.canFullAccess}
          new_text="Create Template"
          onNew={() => this.props.navigate(TEMPLATE_CREATE_PATH)}
          onDoubleClick={(record) =>
            this.props.navigateAndCloseTabs(`${TEMPLATE_DETAIL_PATH}/${record.id}`, `${TEMPLATE_DETAIL_PATH}/`)
          }
        />
      </div>
    );
  }
}

const withHooks = (Wrapped) => {
  const ComponentWithHooks = (props) => {
    const canWrite = useAuth("equipmentCategoryTemplate", AUTH_LEVEL.WRITE);
    const canFullAccess = useAuth("equipmentCategoryTemplate", AUTH_LEVEL.FULL_ACCESS);
    const { navigate, navigateAndCloseTabs } = useSmartNavigate();
    return (
      <Wrapped
        {...props}
        canWrite={canWrite}
        canFullAccess={canFullAccess}
        navigate={navigate}
        navigateAndCloseTabs={navigateAndCloseTabs}
      />
    );
  };
  return ComponentWithHooks;
};

export default withHooks(EquipmentCategoryTemplate);
